@file:kotlin.js.JsExport
/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */


package com.narbase.letsgo.web.routing.domain.admin.staff

import com.narbase.letsgo.dto.core.KmmLong
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.admin.AdminUpsertDto
import com.narbase.letsgo.web.dto.admin.DynamicRoleDto
import com.narbase.letsgo.web.dto.admin.ExtendedAdminDto


object UpsertAdminsEndpoint : EndPoint<UpsertAdminsEndpoint.Request, UpsertAdminsEndpoint.Response>() {
    class Request(
        val admin: AdminUpsertDto,
        val roleIds: Array<KmmLong>,
        val isIpLockAuthenticated: Boolean
    )

    class Response
}

